import { setUtmSourceSign } from '@/utils/cookieHandle';
import { useReport } from '@/utils/hooks/useReport';
import { GOTO_QUICK_LOGIN } from '@/constant';
import cookie from 'js-cookie';
/**
 * 通过url参数控制是否进行第三方登录
 */
export async function csdnloginCheck(route: Record<string, any>, loginCallback: Function) {
  // 注册来源utm_source保存
  if (route?.query?.utm_source) {
    setUtmSourceSign(route?.query?.utm_source || '');
  }

  // isLogin参数为配置字符串时，可无限次进行登录授权
  const loginList = ['88', '99', 'always', '1'];

  if (loginList.includes(route?.query?.isLogin) && !localStorage.getItem('access_token') && !cookie.get('UnsafeGitCodeUserName')) {
    const cache_timeStamp = Number(localStorage.getItem('cache_timeStamp') || 0);// 所存储的时间戳
    let loginTimes = Number(localStorage.getItem('cache_loginTimes') || 0); // 一天限制自动登录授权的次数为5次

    // 判断当前时间是不是大于当前存储的时间
    const nowDate = new Date().toLocaleDateString('zh-CN');
    const targetDate = new Date(cache_timeStamp).toLocaleDateString('zh-CN');
    const isToDay = nowDate === targetDate; // 判断是不是同一天点击
    if (!isToDay) {
      // 超过一天重置次数为0
      localStorage.setItem('cache_loginTimes', `0`);
      loginTimes = Number(localStorage.getItem('cache_loginTimes') || 0); // 一天限制自动登录授权的次数为5次
    }
    // 一天自动登录授权的次数（修改为不限制次数）
    if (loginList.includes(route?.query?.isLogin) || !cache_timeStamp || route?.query?.isLogin === '1') {
      const currentTimestamp = Date.now();
      localStorage.setItem('cache_timeStamp', currentTimestamp.toString());
      localStorage.setItem('cache_loginTimes', `${Number(loginTimes) + 1}`); // 登陆一次加一次
      // 独立上报pv
      window.page_title = route.meta?.reportTitle || '';
      await useReport('pageview', {});
      sessionStorage.setItem(GOTO_QUICK_LOGIN, '1');
      // 跳转授权页
      loginCallback();
      return true;
    }
  }
  return false;
};
